import React           from 'react'
import LandingLayout   from '@/Layouts/LandingLayout'
import { Container }   from '@/Components/Container'
import { useTitle }    from '@/Utilities/Hooks'
import { InertiaLink } from "@inertiajs/inertia-react";

export default function Locked() {
  useTitle('Organization locked')

  return (
    <Container size="max-w-2xl bg-white self-center md:dots-topright md:dots-bottomleft overflow-visible relative p-4 md:p-16 md:mt-10">
      <div className="flex flex-col items-start">
        <a href="/">
          <img
            className="self-start w-16 h-16 mb-8"
            src="/images/logo_dark.png"
            alt="Gidås logo"
          />
        </a>
        <h1 className="mb-2 text-2xl">Your organization has been locked</h1>
        <p>Sorry, but you are not allowed to access Emma with this organization</p>

        <InertiaLink
          method="post"
          as="button"
          className="mt-8 btn-blue"
          href="/logout"
        >
          Log out
        </InertiaLink>
      </div>
    </Container>
  )
}

Locked.layout = page => (
  <LandingLayout>{page}</LandingLayout>
)
